module.exports = __webpack_public_path__ + "static/media/Stellar Neo Queen Headboard - 155 cm_Black.b3f15346.png";